import { render, staticRenderFns } from "./SFmain.vue?vue&type=template&id=7b0ef174&"
import script from "./SFmain.vue?vue&type=script&setup=true&lang=js&"
export * from "./SFmain.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./SFmain.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports